
import axios from 'axios';
import { STATUS_PAGE } from '@mdc/constants';
import PubSub from '../generic-pub-sub/GenericPubSub';
import { localStorage } from '@mdc/services';

const INCIDENT_ID = 'incidentId';

export const SERVICE_ERRORS = {
    ERROR: 'Error loading statuspage',
};

class StatusPageService extends PubSub {
    constructor(){
        super(SERVICE_ERRORS);
    }

    getIncident = async () => {
        const env = process.env.ENVIRONMENT === 'prod' ?  process.env.ENVIRONMENT : 'qa';
        const url = 'https://'+ STATUS_PAGE[env].pageId + '.' + STATUS_PAGE.url + 'incidents/unresolved.json?api_key=' + STATUS_PAGE.apikey;
        try {
            const results = await axios.get(url);
            const lsIncidentID = localStorage.getItem(INCIDENT_ID);

            if (results && results.data && results.data.incidents) {
                if (results.data.incidents.length > 0) {
                    const components = results.data.incidents[0]?.components;
                    components?.sort((componentA, componentB) => {
                        return new Date(componentA.created_at).getTime() -
                            new Date(componentB.created_at).getTime();
                    }).reverse();

                    const latestIncident = components[0];
                    if (latestIncident.group_id === STATUS_PAGE[env].cloudGroupId) {
                        if (!lsIncidentID || (lsIncidentID && lsIncidentID !== `${latestIncident.id}-dismissed`)) {
                            localStorage.setItem(INCIDENT_ID, latestIncident.id);
                            return latestIncident.id;
                        }
                    }
                } else {
                    localStorage.removeItem(INCIDENT_ID);
                }
            }
        } catch (error) {
            this._publish(this.topics.ERROR, error);
        }
    }

}

export default new StatusPageService();
